module.exports = __webpack_public_path__ + "assets/dots-73373249791f95510d09cff17513cce1.svg";